module.exports = {
	"library.navbar.sign_up": "Registrera dig",
	"library.navbar.sign_in": "Logga in",
	"library.navbar.sign_out": "Logga ut",
	"library.navbar.help": "Hjälp",
	"library.navbar.search_for_events": "Sök efter evenemang",
	"library.navbar.enter_location": "Ange plats",
	"library.navbar.find_events": "Hitta evenemang",
	"library.navbar.create_event": "Skapa evenemang",
	"library.navbar.host_events": "Arrangera evenemang",
	"library.navbar.dashboard": "Kontrollpanel",
	"library.navbar.my_events": "Mina evenemang",
	"library.navbar.my_tickets": "Mina biljetter",
	"library.navbar.admin_panel": "Administratörspanel",
	"library.navbar.profile": "Profil",
	"library.navbar.messages": "Meddelanden",
	"library.navbar.settings": "Inställningar",
	"library.navbar.search_cities": "Sök på städer",
	"library.navbar.help_center": "Hjälpcenter",
	"library.navbar.cant_find_tickets": "Var är mina biljetter?",
	"library.navbar.contact_organizer": "Kontakta evenemangets arrangör",
	"library.navbar.can_refund": "Kan jag få pengarna tillbaka?"
};


//////////////////
// WEBPACK FOOTER
// ./~/@uniiverse/library/components/navbar/translations/sv.json
// module id = 1517
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16